import classNames from "classnames"

import { Color } from "../../../../../constants/V2/color"
import Link from "../../../../elements/Link"
import GatsbyStoryblokImage from "../../../../elements/V2/GatsbyStoryblokImage"
import Typography from "../../../../elements/V2/Typography"

import React from "react"

type Props = {
  name: string
  thumbnail: Storyblok.Asset
  link: string | Storyblok.Link | YocoCom.YocoLink
  color?: Color
  backgroundColor?: Color
}

const getColorClasses = (backgroundColor?: Color): string => {
  switch (backgroundColor) {
    case Color.White:
      return "bg-light-gray md:bg-white md:hover:bg-light-gray"
    case Color.LightGray:
      return "bg-white md:bg-light-gray md:hover:bg-white"
    default:
      return "bg-white/20 md:hover:bg-white/20"
  }
}

const CatalogueHeroItem = ({
  name,
  thumbnail,
  link,
  color = Color.Black,
  backgroundColor,
}: Props) => {
  return (
    <Link
      link={link}
      className={classNames(
        "flex h-full cursor-pointer flex-col gap-[12px] rounded-12 p-8 transition duration-200 md:h-auto",
        getColorClasses(backgroundColor)
      )}
    >
      <div className="flex h-[68px] w-[90px] items-center justify-center rounded-8 px-[11px] md:bg-transparent">
        <GatsbyStoryblokImage
          image={thumbnail.filename}
          alt={name}
          aspectRatio="1:1"
        />
      </div>
      <Typography
        element="span"
        text={name}
        size="body-sm"
        font="grotesk"
        weight="book"
        color={color}
        className="max-w-96 text-center"
      />
    </Link>
  )
}

export default CatalogueHeroItem
